import { useFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { useListType } from 'Stores/ListStore/ListStore';
import type { ListType } from 'Types/listType';
import isCorrectVehicleListFetchingState from 'Utilities/helpers/isCorrectVehicleListFetchingState';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';
import useSaleTimes from 'Utilities/hooks/useSaleTimes';

export interface UseFiltersInterface {
	includeSold: boolean;
	includeUnderOffer: boolean;
}

// Buying Format will no longer be nullable once next sale feature toggle is removed.
const useShouldFetchVehicles = (initialListType: Nullable<ListType> = null): boolean => {
	const { isLiveSaleEnabled, isSaleActive } = useSaleTimes();
	const { includeSold, includeUnderOffer } = useFilters() as UseFiltersInterface;
	const listType = useListType();
	const isVehicleListDisabled = useFeatureToggle(FEATURES.showDownloadCSVButtonOutsideList);

	if (isVehicleListDisabled) return false;

	const hasAlwaysFetchFilter = includeSold || includeUnderOffer;

	return isCorrectVehicleListFetchingState({
		hasAlwaysFetchFilter,
		isLiveSaleEnabled,
		isSaleActive,
		listType: listType || initialListType,
	});
};

export default useShouldFetchVehicles;
